<template>
    <b-form-group :label-class='labelclass' :label="label"
        :class="`${responsiveCols} ${classFormGroup} b-form-group-styled`">
        <b-form-select :value="value" @change="change" @input="(id) => $emit('input', id)" v-bind="$attrs"
            class="form-control b-form-input-styled" :text-field="textField ? textField : undefined"
            :value-field="valueField ? valueField : undefined"></b-form-select>
    </b-form-group>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        cols: String,
        sm: String,
        md: String,
        classFormGroup: {
            type: String,
            default: "",
        },
        labelclass: {
            type: String,
            default: "",
        },
        label: String,
        value: [String, Number, Boolean, Object],
        textField: [String, undefined],
        valueField: [String, Number, Boolean, undefined]
    },
    data() {
        return {
            responsiveCols: String,
        }
    },
    methods: {
        change() {
            this.$emit('change')
        }
    },
    mounted() {
        this.responsiveCols =
            (this.cols !== undefined ? `col-${this.cols} ` : "") +
            (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
            (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 "
    },
}
</script>
<style>
.b-form-group-styled {
    font-size: 12px;
}

.b-form-input-styled {
    max-height: 21px;
    margin-top: -2px;
    font-size: 12px;
    padding-left: 3px;
    padding-top: 0px;
    padding-bottom: 0px;
}
</style>
